import { pad } from './'
import { AbstractDateRange } from '../generated'

const DateRange = AbstractDateRange
export default DateRange

/** @constructor @extends {AbstractDateRange} @suppress {checkTypes} */ function _DateRange() {}
AbstractDateRange.__implement(
 _DateRange.prototype = /** @type {!AbstractDateRange} */ ({
  get StartDate() {
   const{startYear,startMonth,startDate,startHours}=this
   let res=null
   if(startYear&&startMonth!=null&&startDate!=null)res=new Date(startYear,startMonth,startDate,startHours)
   return res
  },
  get EndDate() {
   const{endYear,endDate,endHours,endMonth}=this
   let res=null
   if(endYear&&endMonth!=null&&endDate!=null)res=new Date(endYear,endMonth,endDate,endHours)
   return res
  },
  formatDate(date, withHours = true) {
   if (!date) return ''
   let s = `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`
   if (!withHours) return s
   const h = ` ${date.getHours()}:00`
   s += h
   return s
  },
 }),
)